var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboardDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_1014)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20005 2.80002V4.00002H4.00005V17.2H16V4.00002H14.8V2.80002H16C16.6628 2.80002 17.2 3.33728 17.2 4.00002V18.4C17.2 19.0628 16.6628 19.6 16 19.6H4.00005C3.33731 19.6 2.80005 19.0628 2.80005 18.4V4.00002C2.80005 3.33728 3.33731 2.80002 4.00005 2.80002H5.20005ZM14.3455 6.84088L14.3597 6.85504C14.6052 7.10871 14.6052 7.51141 14.3597 7.76508L8.13164 14.2L5.64044 11.626C5.39492 11.3724 5.39492 10.9697 5.64044 10.716C5.84968 10.4998 6.17949 10.4708 6.42102 10.6323L6.52121 10.716V10.716L8.13164 12.3799L13.4789 6.85504C13.7143 6.61182 14.1023 6.60548 14.3455 6.84088ZM10 0.400024C10.6628 0.400024 11.2 0.937283 11.2 1.60002H12.4C13.0628 1.60002 13.6 2.13728 13.6 2.80002V4.00002H6.40005V2.80002C6.40005 2.13728 6.93731 1.60002 7.60005 1.60002H8.80005C8.80005 0.937283 9.33731 0.400024 10 0.400024Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_1014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardDone);
export default __webpack_public_path__ + "static/media/clipboard-done.f38ed971.svg";
export { ForwardRef as ReactComponent };